module.exports = __webpack_public_path__ + "img/plan2.37c4fc1d.svg";